import { useMutation } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  CreateAccountRequest,
  CreateAccountResponse,
} from './create-account.types'

const createAccount = async (
  payload: CreateAccountRequest,
): Promise<CreateAccountResponse> => {
  const response = await apiClient.post<CreateAccountResponse>(
    '/v1/auth/create-account',
    payload,
  )
  return response.data
}

export const useCreateAccount = () => {
  return useMutation({
    mutationFn: (payload: CreateAccountRequest) => createAccount(payload),
  })
}
